import {
  LEAD_MARKETING2_REPORT1_REQUEST,
  LEAD_MARKETING2_REPORT1_SUCCESS,
  LEAD_MARKETING2_REPORT1_FAIL,
  LEAD_MARKETING2_REPORT2_FAIL,
  LEAD_MARKETING2_REPORT2_REQUEST,
  LEAD_MARKETING2_REPORT2_SUCCESS,
  LEAD_MARKETING2_REPORT3_FAIL,
  LEAD_MARKETING2_REPORT3_REQUEST,
  LEAD_MARKETING2_REPORT3_SUCCESS,
  LEAD_MARKETING2_REPORT4_REQUEST,
  LEAD_MARKETING2_REPORT4_FAIL,
  LEAD_MARKETING2_REPORT4_SUCCESS,
  LEAD_MARKETING2_REPORT5_REQUEST,
  LEAD_MARKETING2_REPORT5_FAIL,
  LEAD_MARKETING2_REPORT5_SUCCESS,
} from "../constant/LeadMarketing2Constant";

export const report1Reducer = (state = {}, action) => {
  switch (action.type) {
    case LEAD_MARKETING2_REPORT1_REQUEST:
      return { loading: true };
    case LEAD_MARKETING2_REPORT1_SUCCESS:
      return { loading: false, rep1Data: action.payload };
    case LEAD_MARKETING2_REPORT1_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const report2Reducer = (state = {}, action) => {
  switch (action.type) {
    case LEAD_MARKETING2_REPORT2_REQUEST:
      return { loading: true };
    case LEAD_MARKETING2_REPORT2_SUCCESS:
      return { loading: false, rep2Data: action.payload };
    case LEAD_MARKETING2_REPORT2_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const report3Reducer = (state = {}, action) => {
  switch (action.type) {
    case LEAD_MARKETING2_REPORT3_REQUEST:
      return { loading: true };
    case LEAD_MARKETING2_REPORT3_SUCCESS:
      return { loading: false, rep3Data: action.payload };
    case LEAD_MARKETING2_REPORT3_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const report4Reducer = (state = {}, action) => {
  switch (action.type) {
    case LEAD_MARKETING2_REPORT4_REQUEST:
      return { loading: true };
    case LEAD_MARKETING2_REPORT4_SUCCESS:
      return { loading: false, rep4Data: action.payload };
    case LEAD_MARKETING2_REPORT4_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const report5Reducer = (state = {}, action) => {
  switch (action.type) {
    case LEAD_MARKETING2_REPORT5_REQUEST:
      return { loading: true };
    case LEAD_MARKETING2_REPORT5_SUCCESS:
      return { loading: false, rep5Data: action.payload };
    case LEAD_MARKETING2_REPORT5_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
